import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import ListAction from 'core/actions/ListAction'

const { cinder } = ApiClient.getInstance()

export const cinderMessageActions = ActionsSet.make<DataKeys.CinderMessages>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.CinderMessages,
  cacheKey: DataKeys.CinderMessages,
  addCacheKey: DataKeys.CinderMessages,
})

export const listCinderMessages = cinderMessageActions.add(
  new ListAction<DataKeys.CinderMessages>(async () => {
    return cinder.getCinderMessages()
  }),
)

export const cinderMessagesForVolumeActions = ActionsSet.make<DataKeys.CinderMessagesForVolume>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.CinderMessagesForVolume,
  cacheKey: DataKeys.CinderMessagesForVolume,
  addCacheKey: DataKeys.CinderMessagesForVolume,
})

export const listCinderMessagesForVolume = cinderMessagesForVolumeActions.add(
  new ListAction<DataKeys.CinderMessagesForVolume>(
    async ({ volumeUuid }: { volumeUuid: string }) => {
      return cinder.getCinderMessagesForVolume(volumeUuid)
    },
  ),
)

export const cinderSingleMessageActions = ActionsSet.make<DataKeys.CinderMessage>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.CinderMessage,
  cacheKey: DataKeys.CinderMessage,
  addCacheKey: DataKeys.CinderMessage,
})

export const getCinderSingleMessage = cinderSingleMessageActions.add(
  new ListAction<DataKeys.CinderMessage>(
    async ({ messageId, resourceUuid }: { messageId: string; resourceUuid?: string }) => {
      return cinder.getCinderMessage(messageId, resourceUuid)
    },
  ),
)
